// Espías, rescates y el destino de un real cautivo (`espionage.enabled` y
// `diplomacy.dynasty`) — español. Se une en ./messages.ts.

export const gameEspionageEs = {
  'espionage.tab': 'Misiones',
  'espionage.empty':
    'Nada que hacer. Tus espías están ociosos y ningún real de tu casa está encadenado.',
  'espionage.spies': 'Tus espías',
  'espionage.noSpies':
    'No tienes espías. Un espía puede vigilar cualquier ciudad enemiga contigua.',
  'espionage.endurance': 'Resistencia {n}',
  'espionage.targets': 'Ciudades al alcance',
  'espionage.dispatch': 'Enviar a vigilar',
  'espionage.sabotage': 'Sabotear ({gold} de oro)',
  'espionage.sabotageUnderway': 'En camino: faltan {n} ticks',
  'espionage.sabotageCooldown': 'Tus espías necesitan {n} ticks para el siguiente golpe',
  'espionage.sabotageRefused': 'La orden fue rechazada: revisa al espía, el tesoro y la red',
  'espionage.poison': 'Envenenar el {supply} ({gold} de oro)',
  'espionage.poisoned': 'El {supply} está envenenado',
  'espionage.supplyWell': 'pozo',
  'espionage.supplyGranary': 'granero',
  'espionage.poisonRefused': 'La orden fue rechazada: revisa al espía, el tesoro y la red',
  'espionage.assassinate': 'Asesinar a {royal} ({gold} de oro)',
  'espionage.assassinateRefused': 'La orden fue rechazada: revisa al asesino y el tesoro',
  'espionage.royalTargets': 'Realeza al alcance',
  'espionage.counterGuard': 'Vigilar {city}',
  'espionage.counterGuarding': 'Vigilando {city}',
  'espionage.counterRecall': 'Retirarse',
  'espionage.counterSweep': 'Rastrear agentes ocultos ({gold} de oro)',
  'espionage.counterCatch': 'Intentar atrapar al agente',
  'espionage.counterRefused': 'La orden fue rechazada: revisa la unidad, el tesoro y el objetivo',
  'espionage.frameLabel': 'A quién culpar',
  'espionage.frameNobody': 'No culpar a nadie',
  'espionage.frameHouse': 'Culpar a {house}',
  'espionage.dispatched': 'Espía enviado',
  'espionage.watching': 'Vigilando',
  'espionage.gathering': 'Recopilando lo que oye…',
  'espionage.attackPrepared': 'Reúnen tropas',
  'espionage.attackNotPrepared': 'Ninguna tropa reunida',
  'espionage.units': '{n} unidades',
  'espionage.gold': '{n} de oro',
  'espionage.people': '{n} almas',
  'espionage.loyalty': 'Lealtad {n}',
  'espionage.mood': 'Ánimo {n}',
  'espionage.faith': 'Fe {n}',
  'espionage.buildings': 'Edificios: {list}',
  'espionage.agents': 'Agentes que retienes',
  'espionage.agentOf': '{kind} de {house}',
  'espionage.agentRansom': 'Rescate ({gold} de oro)',
  'espionage.agentRelease': 'Soltar',
  'espionage.agentExecute': 'Ejecutar',
  'espionage.agentRefused': 'Su casa no puede pagar.',
  'espionage.agentKind.spy': 'Un espía',
  'espionage.agentKind.assassin': 'Un asesino',
  'espionage.captives': 'Reales que retenes',
  'espionage.taken': 'Tus reales, cautivos',
  'espionage.heldSince': 'Retenido desde la ticada {n}',
  'espionage.decision': 'Decisión',
  'espionage.undecided': 'Aún sin decisión',
  'espionage.choiceRansom': 'Rescate',
  'espionage.choiceHold': 'Retener',
  'espionage.choiceExecute': 'Ejecutar',
  'espionage.choiceRelease': 'Liberar',
  'espionage.price': 'Precio {n} de oro',
  'espionage.payRansom': 'Pagar el rescate',
  'espionage.rescue': 'Enviar un espía',
  'espionage.raid': 'Tomar el lugar por la fuerza',
  'espionage.alreadyTried': 'Ya se intentó un rescate aquí',
  'espionage.captor.title': '¿Qué le ocurre a {name}?',
  'espionage.captor.body': 'Retienes a un real de otra casa. La corte recordará lo que decidas.',
  'espionage.captor.ransomBody': 'Pide oro. Si nadie paga, el real solo queda retenido.',
  'espionage.captor.holdBody': 'Retenlo. Un real retenido todavía puede escaparse por su cuenta.',
  'espionage.captor.executeBody': 'Acábalo ahora. Una muerte se recuerda como una muerte.',
  'espionage.captor.releaseBody': 'Suéltalo. No se gana nada y no se pierde nada.',
  'espionage.captor.confirm': 'Decidir',
  'espionage.captor.cancel': 'Todavía no',
} as const;
